import { Action, Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { onPageDidMount } from '../redux/core';
import { RootState } from '../redux/types';
import { Scheduling, StateProps, DispatchProps } from '../components/scheduling/Scheduling';
import { setDate, setShowPairingRules } from '../redux/ui/actions';
import { fetchPairingRules } from '../redux/scheduling/actions';
import { toast } from '../redux/message/actions';

export function mapStateToProps(state: RootState): StateProps {
  let markets: string[] = [];
  if (state.markets.markets.data) {
    const marketSet = new Set(
      state.markets.markets.data.map((market) => {
        return market.groupCode;
      })
    );
    markets = Array.from(marketSet);
  }

  return {
    dailyShiftSchedule: state.scheduling.dailyShiftSchedule,
    date: state.ui.date,
    marketGroups: markets,
    markets: state.markets.markets.data ? state.markets.markets.data : [],
    pairingRules: state.scheduling.pairingRules,
    ui: state.ui,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
  return {
    actions: bindActionCreators({ onPageDidMount, setDate, toast, setShowPairingRules, fetchPairingRules }, dispatch),
  };
}

export const SchedulingContainer = connect<StateProps, DispatchProps, any, RootState>(mapStateToProps, mapDispatchToProps)(Scheduling);
